import { END_POINTS } from '../helpers';
import { CommonBody, PromoCodeRes } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};
export const PromocodeApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addPromoCode: builder.mutation<CommonResponse & { data: any }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addPromoCode}`,
        method: 'POST',
        body,
      }),
    }),
    addDealerDropdownForPromo: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.DealerDropdownForPromo}`,
        method: 'POST',
        body,
      }),
    }),
    updatePromoCode: builder.mutation<
      CommonResponse & { data: any },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updatePromoCode}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    getPromoCodeById: builder.query<CommonResponse & { data: any }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getPromoCodeById}/${id}`,
        method: 'GET',
      }),
    }),
    deletePromoCode: builder.mutation<CommonResponse & { data: any }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deletePromoCode}/${id}`,
        method: 'DELETE',
      }),
    }),
    getPromoCode: builder.query<
      CommonResponse & { data: PromoCodeRes },
      { page: number; limit: number; search?: string }
    >({
      query: ({ page, limit, search }) => {
        const params = new URLSearchParams();
        if (search) {
          params.append('search', search);
        }
        return {
          url: `${END_POINTS.getPromoCode}?page=${page}&limit=${limit}&${params.toString()}`,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useAddPromoCodeMutation,
  useLazyGetPromoCodeQuery,
  useUpdatePromoCodeMutation,
  useLazyGetPromoCodeByIdQuery,
  useDeletePromoCodeMutation,
  useAddDealerDropdownForPromoMutation,
} = PromocodeApi;
